

<div class="container-fluid">

  <form #obsForm="ngForm">
    <div class="row top10 no-gutters">
      <div class="col-xs-12 col-lg-4 vcenter">
        <h3>ARS Observation Report - {{ observation?.obsInspNum || 'New'}}</h3>
      </div>
      <div class="col-xs-12 col-lg-8 vcenter-right">
        <div class="btn-group" role="group" aria-label="...">
          <button type="button" class="btn btn-default btn-sm" *ngIf="obsForm.form.dirty"
            [disabled]="saveClicked || !obsForm.form.dirty || !calculateEditable()" (click)="cancelObsUpdate()">
            <i class="fas fa-ban"></i>&nbsp;Cancel
          </button>
          <button type="button" class="btn btn-default btn-sm" *ngIf="obsForm.form.dirty"
            [disabled]="(saveClicked || !obsForm.valid || !obsForm.form.dirty || !calculateEditable())"
            (click)="saveObservation()">
            <i class="fas fa-save"></i>&nbsp;Save
          </button>
          <button *ngIf="calculateEditable()" type="button" class="btn btn-default btn-sm"
            (click)="doRebuttalComment()">
            <i class="fas fa-thumbs-down"></i>&nbsp;Rebuttal Comment
          </button>
          <button type="button" class="btn btn-default btn-sm" *ngIf="canQcApprove() && calculateEditable()"
            [disabled]="(!obsForm.valid || obsForm.form.dirty)" (click)="qcFinalApproval()">
            <i class="fas fa-thumbs-up"></i>&nbsp;QC Approve
          </button>
          <button type="button" class="btn btn-default btn-sm" *ngIf="(canPmmApproveOrReject() && qcFinalApproved())"
            (click)="pmmFinalApproval()">
            <i class="fas fa-thumbs-up"></i>&nbsp;Approve
          </button>
          <button type="button" class="btn btn-default btn-sm" *ngIf="(canPmmApproveOrReject() && qcFinalApproved())"
            (click)="pmmRejected()">
            <i class="fas fa-thumbs-down"></i>&nbsp;Reject
          </button>

        </div>
      </div>
    </div>
    <hr style="margin-top:2px;margin-bottom:2px" />

    <ng-container *ngIf="observation !== undefined">
      <aims-form cols="4">
        <aims-fc [showDescendants]="false">
          <aims-form cols="1" [editable]="calculateEditable()">
            <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-select #aimsControl="ngModel"
                                [(ngModel)]="observation.originTypeId"
                                name="Origin"
                                (selectionChange)="originChanged($event)"
                                required>
                        <mat-option *ngFor="let o of originTypeValues | async" [value]="o.originTypeId">
                            {{ o.originType }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </aims-fc>
            <ng-container> <!-- *ngIf="showQaFields | async"> -->
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <aims-lookup
                  #aimsControl="ngModel"
                  name="Inspection Report"
                  id="inspectionReport"
                  class="fullWidth"
                  maxlength="100"
                  [gridText]="'Select an Inspection Report'"
                  [values]="inspectionReportValues | async"
                  [idPropertyName]="'inspectionReportId'"
                  [displayPropertyName]="'reportName'"
                  [(ngModel)]="observation.inspectionReportId"
                  [columnsInGrid]="inspectionReportLookupColumns"
                  [disabled]="!canCreate()"
                  (valueChange)="inspRptChanged($event)"
                  [linkHref]="'/projectSupport/inspectionReport/'+observation.inspectionReportId">
                </aims-lookup>
              </aims-fc>
            </ng-container>
            <ng-container *ngIf="showQaFields | async">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <input matInput #aimsControl="ngModel" class="fullWidth" name="QA CAR Number" type="text"
                    maxlength="30" [disabled]="!canCreate()" [(ngModel)]="observation.qaCarNumber"
                    required />
                </mat-form-field>
              </aims-fc>
            </ng-container>
            <ng-container *ngIf="showQaFields | async">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <input matInput #aimsControl="ngModel" class="fullWidth" name="QA Report Number" type="text"
                    [disabled]="!canCreate()" [(ngModel)]="observation.reportNumber" />
                </mat-form-field>
              </aims-fc>
            </ng-container>

            <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-select #aimsControl="ngModel"
                                [(ngModel)]="observation.siteId"
                                name="Site"
                                [disabled]="!canCreate()"
                                required>
                        <mat-option *ngFor="let s of siteValues | async" [value]="s.siteId">
                            {{ s.siteName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </aims-fc>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-select #aimsControl="ngModel"
                                [(ngModel)]="observation.deficiencyTypeId"
                                name="Deficiency Type"
                                [disabled]="!canCreate()"
                                (selectionChange)="rdtChanged()"
                                required>
                        <mat-option *ngFor="let d of deficiencyTypeValues | async" [value]="d.deficiencyTypeId">
                            {{ d.deficiencyType }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </aims-fc>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-select #aimsControl="ngModel"
                                [(ngModel)]="observation.observationTypeId"
                                name="Observation Type"
                                [disabled]="!canCreate()"
                                required>
                        <mat-option *ngFor="let o of observationTypeValues" [value]="o.observationTypeId">
                            {{ o.observationType }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </aims-fc>
          </aims-form>
        </aims-fc>
        <aims-fc [showDescendants]="false">
          <aims-form cols="1" [editable]="calculateEditable()">
            <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-select #aimsControl="ngModel"
                                [(ngModel)]="observation.responsibleManagerId"
                                name="Responsible Manager"
                                [disabled]="!canCreate()"
                                required>
                        <mat-option *ngFor="let m of responsibleManagerValues | async" [value]="m.responsibleManagerId">
                            {{ m.responsibleManager }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </aims-fc>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
              <aims-lookup
                #aimsControl="ngModel"
                name="Work Section"
                id="WorkSection"
                class="fullWidth"
                [gridText]="'Select a Work Section'"
                [values]="workSectionValues | async"
                [idPropertyName]="'workSectionId'"
                [displayPropertyName]="'workSection'"
                [(ngModel)]="observation.workSectionId"
                [columnsInGrid]="workSectionLookupColumns"
                [disabled]="canUpdate()"
                [required]="!(observation.workSectionSuspenseDate == null)">
              </aims-lookup>
            </aims-fc>
            <ng-container *ngIf="observation.oldJobControlNumber !== null">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <input matInput #aimsControl="ngModel" class="fullWidth" name="OLD JCN/JOL #" type="text"
                    [disabled]="!canCreate()" [(ngModel)]="observation.oldJobControlNumber" />
                </mat-form-field>
              </aims-fc>
            </ng-container>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-select #aimsControl="ngModel"
                                [(ngModel)]="observation.areaId"
                                name="Area"
                                [disabled]="!canCreate()"
                                required>
                        <mat-option *ngFor="let a of areaValues | async" [value]="a.areaId">
                            {{ a.area }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </aims-fc>
          </aims-form>
        </aims-fc>
        <aims-fc [showDescendants]="false">
          <aims-form cols="1" [editable]="calculateEditable()">
            <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-label></mat-label>
                    <input name="Inspection Date" matInput #aimsControl="ngModel" [matDatepicker]="inspectionDate" [(ngModel)]="observation.inspectionDate" [disabled]="canUpdate()" required>
                    <mat-datepicker-toggle matSuffix [for]="inspectionDate"></mat-datepicker-toggle>
                    <mat-datepicker #inspectionDate></mat-datepicker>
                </mat-form-field>
            </aims-fc>
            <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-label></mat-label>
                    <input name="Opened Date" matInput #aimsControl="ngModel" [matDatepicker]="openedDate" [(ngModel)]="observation.openedDate" [disabled]="canUpdate()">
                    <mat-datepicker-toggle matSuffix [for]="openedDate"></mat-datepicker-toggle>
                    <mat-datepicker #openedDate></mat-datepicker>
                </mat-form-field>
            </aims-fc>

            <ng-container *ngIf="isCAR()">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-label></mat-label>
                    <input name="Work Section Suspense" matInput #aimsControl="ngModel" [matDatepicker]="wsSuspense" [(ngModel)]="observation.workSectionSuspenseDate" [disabled]="canUpdate()">
                    <mat-datepicker-toggle matSuffix [for]="wsSuspense"></mat-datepicker-toggle>
                    <mat-datepicker #wsSuspense></mat-datepicker>
                </mat-form-field>
              </aims-fc>
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-label></mat-label>
                    <input name="Work Section C/W" matInput #aimsControl="ngModel" [matDatepicker]="wsCW" [(ngModel)]="observation.workSectionCompDate" [disabled]="canUpdate()">
                    <mat-datepicker-toggle matSuffix [for]="wsCW"></mat-datepicker-toggle>
                    <mat-datepicker #wsCW></mat-datepicker>
                </mat-form-field>
              </aims-fc>
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-label></mat-label>
                    <input name="Manager ECD" matInput #aimsControl="ngModel" [matDatepicker]="mgmtECD" [(ngModel)]="observation.managerEstCompDate" [disabled]="canUpdate()">
                    <mat-datepicker-toggle matSuffix [for]="mgmtECD"></mat-datepicker-toggle>
                    <mat-datepicker #mgmtECD></mat-datepicker>
                </mat-form-field>
              </aims-fc>
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-label></mat-label>
                    <input name="Manager C/W" matInput #aimsControl="ngModel" [matDatepicker]="mgmtCW" [(ngModel)]="observation.managerCompDate" [disabled]="canUpdate()">
                    <mat-datepicker-toggle matSuffix [for]="mgmtCW"></mat-datepicker-toggle>
                    <mat-datepicker #mgmtCW></mat-datepicker>
                </mat-form-field>
              </aims-fc>
            </ng-container>
          </aims-form>
        </aims-fc>
        <aims-fc [showDescendants]="false">

          <aims-form cols="1" [editable]="calculateEditable()">
            <ng-container *ngIf="isCAR()">
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                 <mat-form-field>
                    <mat-select #aimsControl="ngModel"
                                [(ngModel)]="observation.rootCauseId"
                                name="Root Cause"
                                [disabled]="!canCreate()"
                                [required]="observation.managerCompDate != null">
                        <mat-option *ngFor="let r of rootCauseValues | async" [value]="r.rootCauseId">
                            {{ r.rootCause }}
                        </mat-option>
                    </mat-select>
                 </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-label></mat-label>
                    <input name="QC Final Review" matInput #aimsControl="ngModel" [matDatepicker]="qcReview" [(ngModel)]="observation.finalReviewDate" disabled>
                    <mat-datepicker-toggle matSuffix [for]="qcReview"></mat-datepicker-toggle>
                    <mat-datepicker #qcReview></mat-datepicker>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <mat-form-field>
                    <mat-label></mat-label>
                    <input name="Project Manager Review Date" matInput #aimsControl="ngModel" [matDatepicker]="pmReview" [(ngModel)]="observation.projMngrReviewedDate" disabled>
                    <mat-datepicker-toggle matSuffix [for]="pmReview"></mat-datepicker-toggle>
                    <mat-datepicker #pmReview></mat-datepicker>
                </mat-form-field>
              </aims-fc>
            </ng-container>

            <ng-container>
              <aims-fc [labelColSize]="5" [controlColSize]="7">
                <input #aimsControl="ngModel" type="checkbox" name="Valid ?" title="Valid CAR or CDI?"
                  [(ngModel)]="observation.isValid" [disabled]="!canCreate()" tabindex="-1" />
              </aims-fc>
            </ng-container>
          </aims-form>
        </aims-fc>
      </aims-form>

      <aims-form cols="1" [editable]="calculateEditable()">
        <aims-fc [labelColSize]="12" [controlColSize]="12">
            <mat-form-field>
                <textarea matInput #aimsControl="ngModel" name="Non-Conformance" style="width:100%" rows="5" cdkTextareaAutosize
                    [disabled]="!canCreate()" [(ngModel)]="observation.nonConformance" required>
                    </textarea>
            </mat-form-field>
        </aims-fc>
      </aims-form>
      <br />

      <mat-tab-group>
        <mat-tab label="Required Action(s)">
          <ng-template matTabContent>
            <aims-form cols="1" [editable]="calculateEditable()" [header]="'***Actions Items Required to Close***'"
              [hider]="true">
              <aims-fc [labelColSize]="12" [controlColSize]="12">
              <mat-card>
                <aims-common-table
                  id="action-table"
                  [dataSource]="observation.qcObservationRequiredActions"
                  [defaultTableState] = "{ sort:{ active : 'orderNumber', direction: 'asc' }}"
                  [addRowInitialObject]="defaultAction"
                  [header]="actionTableHeader"
                  [permissions]="actionTablePermissions"
                  [pageSize]="10"
                  (rowEdit)="actionRowEdit($event)"
                  (rowUpdated)="actionRowUpdated($event)"
                  (rowDeleted)="actionRowDeleted($event)"
                  (rowAdded)="actionRowAdded($event)"
                  [stickyHeader]="true">

                  <aims-common-table-dynamic-row id="completedById">
                    <ng-template viewMode let-element >
                      {{ element.completedById | getText:'employeeId':'fullName':employeeValues }}
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <aims-common-table-dynamic-row id="certifiedById">
                    <ng-template viewMode let-element >
                      {{ element.certifiedById | getText:'employeeId':'fullName':employeeValues }}
                    </ng-template>
                  </aims-common-table-dynamic-row>
                </aims-common-table>
              </mat-card>

              </aims-fc>
            </aims-form>
          </ng-template>
        </mat-tab>

        <mat-tab label="Reference(s)">
          <ng-template matTabContent>

            <aims-form cols="1" [editable]="calculateEditable()">
              <aims-fc [labelColSize]="12" [controlColSize]="12">
                <mat-form-field>
                    <textarea matInput #aimsControl="ngModel" name="PWS Ref" style="width:100%" cdkTextareaAutosize
                    [disabled]="!canCreate()" maxlength="255" [(ngModel)]="observation.pwsReference">
                    </textarea>
                </mat-form-field>
              </aims-fc>
              <aims-fc [labelColSize]="12" [controlColSize]="12">
                <mat-form-field>
                    <textarea matInput #aimsControl="ngModel" name="PWS Desc" style="width:100%" cdkTextareaAutosize
                    [disabled]="!canCreate()" maxlength="2000" [(ngModel)]="observation.pwsRefDesc">
                    </textarea>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="12" [controlColSize]="12">
                <aims-lookup
                  #aimsControl="ngModel"
                  name="Pub Ref"
                  [gridText]="'Select a Publication'"
                  [disabled]="!canCreate()"
                  id="pubRefLookup"
                  [values]="pubValues | async"
                  [idPropertyName]="'publicationId'"
                  [displayPropertyName]="'pubNum'"
                  [(ngModel)]="observation.pubReferenceId"
                  [columnsInGrid]="publicationLookupColumns"
                  style="width:100%">
                  </aims-lookup>
              </aims-fc>

              <aims-fc [labelColSize]="12" [controlColSize]="12">
                <mat-form-field>
                    <textarea matInput #aimsControl="ngModel" name="Pub Desc" style="width:100%" cdkTextareaAutosize
                    [disabled]="!canCreate()" maxlength="2000" [(ngModel)]="observation.pubRefDesc">
                    </textarea>
                </mat-form-field>
              </aims-fc>

              <aims-fc [labelColSize]="12" [controlColSize]="12">
                <mat-form-field>
                    <textarea matInput #aimsControl="ngModel" name="Alt Ref" style="width:100%" cdkTextareaAutosize
                    [disabled]="!canCreate()" maxlength="255" [(ngModel)]="observation.altReference">
                    </textarea>
                </mat-form-field>
              </aims-fc>
              <aims-fc [labelColSize]="12" [controlColSize]="12">
                <mat-form-field>
                    <textarea matInput #aimsControl="ngModel" name="Alt Desc" style="width:100%" cdkTextareaAutosize
                    [disabled]="!canCreate()" maxlength="2000" [(ngModel)]="observation.altRefDesc">
                    </textarea>
                </mat-form-field>
              </aims-fc>
            </aims-form>
          </ng-template>
        </mat-tab>


        <mat-tab *ngIf="observation.observationId != null" label="Attachment(s)">
          <ng-template matTabContent>
            <aims-form cols="1" [editable]="calculateEditable()" [header]="'Attachment(s)'" [hider]="true">
              <aims-fc [labelColSize]="12" [controlColSize]="12">

                <aims-common-table
                  id="attachments-table"
                  [dataSource]="observation.qcObservationAttachments"
                  [addRowInitialObject]="defaultAttachment"
                  [header]="attachmentsTableHeader"
                  [permissions]="attachmentsTablePermissions"
                  [pageSize]="10"
                  (rowUpdated)="attachmentRowUpdated($event)"
                  (rowAdded)="attachmentRowAdded($event)"
                  (rowDeleted)="attachmentRowDeleted($event)"
                  [stickyHeader]="true">

                  <aims-common-table-dynamic-row id="attachment">
                    <ng-template viewMode let-element >
                      <aims-grid-file-display
                        [downloadUrl]="'QualityControl/DisplayObservationAttachment?attachmentId='+element.attachmentId"
                        [fileName]=element.attachmentName>
                      </aims-grid-file-display>
                    </ng-template>

                    <ng-template editMode let-element let-dynamicControl="dynamicControl">
                      <aims-new-grid-file-upload [formControl]="dynamicControl" [fileName]=element.attachmentName ></aims-new-grid-file-upload>
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <aims-common-table-dynamic-row id="addedById">
                    <ng-template viewMode let-element >
                      {{ element.addedById | getText:'employeeId':'fullName':employeeValues }}
                    </ng-template>
                  </aims-common-table-dynamic-row>
                </aims-common-table>

              </aims-fc>
            </aims-form>
          </ng-template>
        </mat-tab>

        <mat-tab *ngIf="canViewWorkOrders()" label="Work Order(s)">
          <ng-template matTabContent>
            <aims-form cols="1" [editable]="calculateEditable()">
              <aims-fc [labelColSize]="12" [controlColSize]="12">
                <aims-common-table
                  id="wo-table"
                  [dataSource]="observation.qcObservationXworkOrders"
                  [addRowInitialObject]="defaultObsXworkOrders"
                  [header]="woTableHeader"
                  [permissions]="woTablePermissions"
                  [pageSize]="10"
                  (rowAdded)="woRowAdded($event)"
                  (rowUpdated)="woRowUpdated($event)"
                  (rowDeleted)="woRowDeleted($event)"
                  [stickyHeader]="true">

                <aims-common-table-dynamic-row id="workOrderId">
                  <ng-template viewMode let-element >
                      <a style="text-decoration:underline;cursor:pointer"
                        [routerLink]="'/assetMgmt/workOrder/' + element.workOrderId"
                        target="_blank">{{ element.workOrderId | getText:'workOrderId':'woDesc':workOrderValues | async }}</a>
                  </ng-template>

                  <ng-template editMode let-element let-dynamicControl="dynamicControl">
                    <aims-lookup
                        [formControl]="dynamicControl"
                        name="Work Order"
                        id="WorkOrder"
                        class="fullWidth"
                        [gridText]="'Select a Work Order'"
                        [values]="workOrderValues | async"
                        [idPropertyName]="'workOrderId'"
                        [displayPropertyName]="'woDesc'"
                        [(ngModel)]="element.workOrderId"
                        [columnsInGrid]="workOrderLookupColumns"
                    >
                    </aims-lookup>
                  </ng-template>
                </aims-common-table-dynamic-row>

                </aims-common-table>

              </aims-fc>
            </aims-form>
          </ng-template>
        </mat-tab>

        <mat-tab *ngIf="showJCNTab" label="Job Control #(s)">
          <ng-template matTabContent>
            <aims-form cols="1" [editable]="calculateEditable()">
              <aims-fc [labelColSize]="12" [controlColSize]="12">
                <aims-common-table
                  id="jcn-table"
                  [dataSource]="observation.qcObservationXjobControlNumbers"
                  [addRowInitialObject]="defaultObsXjcn"
                  [header]="jcnTableHeader"
                  [permissions]="jcnTablePermissions"
                  [pageSize]="10"
                  (rowAdded)="jcnRowAdded($event)"
                  (rowUpdated)="jcnRowUpdated($event)"
                  (rowDeleted)="jcnRowDeleted($event)"
                  [stickyHeader]="true">
                  <aims-common-table-dynamic-row id="jobControlNumber">
                    <ng-template viewMode let-element >
                      {{ element.jobControlNumber | getText:'jcn':'jcnDesc':jcnValues }}
                    </ng-template>

                    <ng-template editMode let-element let-dynamicControl="dynamicControl">
                      <aims-lookup
                          [formControl]="dynamicControl"
                          name="JCN"
                          id="JCN"
                          class="fullWidth"
                          [gridText]="'Select a JCN'"
                          [values]="jcnValues "
                          [idPropertyName]="'jcn'"
                          [displayPropertyName]="'jcnDesc'"
                          [(ngModel)]="element.jobControlNumber"
                          [columnsInGrid]="jcnLookupColumns" >
                      </aims-lookup>
                    </ng-template>
                  </aims-common-table-dynamic-row>
                </aims-common-table>

              </aims-fc>
            </aims-form>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
      <hr/>

      <aims-form [spaceRows]="false" [cols]="1" [header]="'Observation Comment(s)'" [hider]="true">
        <aims-fc [labelColSize]="0" [controlColSize]="12">
        <br/>
        <mat-card>
          <aims-common-table
                  id="comment-table"
                  [dataSource]="observation.qcObservationComments"
                  [addRowInitialObject]="defaultComment"
                  [header]="commentTableHeader"
                  [permissions]="commentTablePermissions"
                  [pageSize]="10"
                  (rowEdit)="commentRowEdit($event)"
                  (rowAdded)="commentRowAdded($event)"
                  (rowUpdated)="commentRowUpdated($event)"
                  [stickyHeader]="true">

                <aims-common-table-dynamic-row id="observationCommentTypeId">
                  <ng-template viewMode let-element >
                    {{ element.observationCommentTypeId | getText:'observationCommentTypeId':'observationCommentType':observationCommentTypeValues | async }}
                  </ng-template>

                  <ng-template editMode let-element let-dynamicControl="dynamicControl">
                    <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
                      <mat-select style="width: 100px" [formControl]="dynamicControl" name="observationCommentTypeId" required>
                        <mat-option *ngFor="let c of observationCommentTypeValues | async" [value]="c.observationCommentTypeId">
                          {{ c.observationCommentType}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="commentById">
                  <ng-template viewMode let-element >
                    {{ element.commentById | getText:'employeeId':'fullName':employeeValues }}
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="attachment">
                  <ng-template viewMode let-element >
                    <aims-grid-file-display
                      [downloadUrl]="'QualityControl/DisplayObservationCommentAttachment?observationCommentId='+element.observationCommentId"
                      [fileName]=element.attachmentName>
                    </aims-grid-file-display>
                  </ng-template>

                  <ng-template editMode let-element let-dynamicControl="dynamicControl" let-idx="idx" >
                     <aims-new-grid-file-upload [formControl]="dynamicControl" [fileName]=element.attachmentName >
                    </aims-new-grid-file-upload>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="attachmentAddedById">
                  <ng-template viewMode let-element >
                    {{ element.attachmentAddedById | getText:'employeeId':'fullName':employeeValues }}
                  </ng-template>
                </aims-common-table-dynamic-row>
          </aims-common-table>
        </mat-card>

        </aims-fc>
      </aims-form>

    </ng-container>
  </form>
  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>

  <app-upload-progress [uploadProgress]="uploadProgress" [fileName]="uploadFileName" [showProgress]="showProgress"></app-upload-progress>
</div>
